






































import SupportPlanDialog from './SupportPlanDialog.vue';
import MonitoringDialog from './MonitoringDialog.vue';

import { MessageDialog } from '../../utils/MessageDialog';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { SupportPlanDTO } from '../../../src_server/entity/dto/SupportPlanDTO';
import { SupportPlanService } from '../../biz/remote/SupportPlanService';
import { dayjs, DW_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { routeHelper, routeHelperOpenNewTab } from '../../utils/routeHelper';

@Component({
  components: { SupportPlanDialog, MonitoringDialog },
  filters: {
    dateFormat: (dt: Date) => {
      if (!dt) return '';
      return dayjs(dt).format(DW_FORMAT_JA);
    },
    monitoringDateFormat: (dt: Date) => {
      if (!dt) return '未作成';
      return dayjs(dt).format(DW_FORMAT_JA);
    },
  },
})
export default class SupportPlanSection extends Vue {
  @Prop({ default: '' })
  private user_id!: string;
  @Prop({ default: false })
  private forDisplay!: boolean;

  private plans: SupportPlanDTO[] = [];

  private get supportPlan() {
    return this.plans.sort((a, b) => {
      return dayjs(b.support_plan.start_dt).diff(dayjs(a.support_plan.start_dt));
    });
  }

  /**
   * 個別支援計画の枠を追加
   */
  async addPlan() {
    const biz = new SupportPlanService();
    const response = await biz.addPlan(this.user_id);
    this.plans.unshift(response.data);
    await MessageDialog.alert(`個別支援計画の入力ページを追加しました`);
  }

  /**
   * 個別支援計画をコピー
   */
  async copy(plan: SupportPlanDTO) {
    if (!plan.support_plan.monitoring_create_dt) {
      await MessageDialog.alert(`モニタリングデータが入力されていません。先にモニタリングを実施してください`);
      return;
    }
    const biz = new SupportPlanService();
    const response = await biz.copyPlan(plan);
    this.plans.unshift(response.data);
    await MessageDialog.alert(`期間の連続する個別支援計画のページを追加しました`);
  }

  /**
   * 個別支援計画を変更するダイアログを表示
   */
  async planChange(plan: SupportPlanDTO) {
    (this.$refs['support-plan-dialog'] as SupportPlanDialog).show(plan);
  }

  async printPage(support_plan_id: number) {
    routeHelperOpenNewTab(this, 'SupportPlanPrintPage', { support_plan_id: support_plan_id });
  }
  async monitoring(plan: SupportPlanDTO) {
    (this.$refs['monitoring-dialog'] as MonitoringDialog).show(plan);
  }

  /**
   * 個別支援計画の変更をリストに反映
   */
  async changed(plan: SupportPlanDTO) {
    this.plans.length;
  }

  /**
   * 個別支援計画を削除
   */
  async deletePlan(plan: SupportPlanDTO) {
    console.log('plan', plan);
    const plan_id = plan.support_plan.support_plan_id;
    if (!plan_id) {
      await MessageDialog.systemError(`個別支援計画ID`, `削除時`);
      return;
    }
    const isOK = await MessageDialog.confirm(`個別支援計画を削除します。この操作はやり直しできません。よろしいですか？`);
    if (isOK) {
      const biz = new SupportPlanService();
      await biz.deletePlan(plan_id);

      // リストから削除
      const index = this.plans.findIndex((v: SupportPlanDTO) => v.support_plan.support_plan_id === plan_id);
      this.plans.splice(index, 1);
    }
  }

  /**
   * 個別支援計画を取得する
   */
  async created() {
    const biz = new SupportPlanService();
    const response = await biz.getPlan(this.user_id);
    this.plans = response.data;
  }
}
